import { ApiManager, Sites } from '@pdrj/pmi-iqos-shared-react'
import IqosphereAuth from './api/iqosphere-auth'
import IqosphereLottery from './api/iqosphere-lottery'
import IqosphereQuiz from './api/iqosphere-quiz'
import IqosphereQuest from './api/iqosphere-quest'
import IqospherePrize from './api/iqosphere-prize'
import IqosphereProfile from './api/iqosphere-profile'
import IqosphereSpots from './api/iqosphere-spots'
import IqosphereStarterPack from './api/iqosphere-starter-pack'
import IqosphereCampaign from './api/iqosphere-campaign'
import IqosphereEvent from './api/iqosphere-event'

class IqosphereApiManager extends ApiManager {
  defaultHeaders = {
    'Content-Type': 'application/json'
  }

  errorCodeTranslationMap = {
    qs_01: 'tk_queryParameterTokenMissing'
  }

  constructor(line) {
    super(Sites.iqosphere, line)
    this.iqosphereAuth = new IqosphereAuth(this)
    this.iqosphereLottery = new IqosphereLottery(this)
    this.iqospherePrize = new IqospherePrize(this)
    this.iqosphereProfile = new IqosphereProfile(this)
    this.iqosphereQuiz = new IqosphereQuiz(this)
    this.iqosphereQuest = new IqosphereQuest(this)
    this.iqosphereSpots = new IqosphereSpots(this)
    this.iqosphereStarterPack = new IqosphereStarterPack(this)
    this.iqosphereCampaign = new IqosphereCampaign(this)
    this.iqosphereEvent = new IqosphereEvent(this)
  }

  getMock = mock => {
    return () => {
      return require(`../mocks/${mock}.json`)
    }
  }
}

export default IqosphereApiManager
